import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import PostGrid from "./post/PostGrid";
import { posts } from "./post/AllPost";
import { useLanguage } from "../context/LanguageContext";
import { useUI } from "../constants/i18n";

const CategorySelector: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedCategory =
    (searchParams.get("category") as "Lost Gem" | "Expose") ?? "Lost Gem";
  const { lang } = useLanguage();
  const ui = useUI(lang);

  const handleCategoryChange = (category: "Lost Gem" | "Expose") => {
    setSearchParams({ category });
  };

  const filteredPosts = useMemo(
    () => posts.filter((post) => post.category === selectedCategory),
    [selectedCategory],
  );

  return (
    <div className="container mx-auto">
      <div
        className="flex justify-end space-x-4 pt-4"
        role="group"
        aria-label="Category filter"
      >
        <button
          onClick={() => handleCategoryChange("Lost Gem")}
          className={`px-4 py-2 text-white ${
            selectedCategory === "Lost Gem"
              ? "bg-[#C1282DFF] underline"
              : "bg-[#606060] hover:bg-[#C1282DFF]"
          }`}
          aria-pressed={selectedCategory === "Lost Gem"}
          aria-label="Show Lost Gems"
        >
          {ui.lostGemsLabel}
        </button>
        <button
          onClick={() => handleCategoryChange("Expose")}
          className={`px-4 py-2 text-white ${
            selectedCategory === "Expose"
              ? "bg-[#C1282DFF] underline"
              : "bg-[#606060] hover:bg-[#C1282DFF]"
          }`}
          aria-pressed={selectedCategory === "Expose"}
          aria-label="Show Exposés"
        >
          {ui.exposesLabel}
        </button>
      </div>
      <PostGrid posts={filteredPosts} />
    </div>
  );
};

export default CategorySelector;
